import Quantity from './containers/Quantity';

export default Quantity;
